<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formTransporter">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="transporterContract.userNameCreate"
              [createDate]="transporterContract.createDate" [userNameUpdate]="transporterContract.userNameUpdate"
              [updateDate]="transporterContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-5 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-12">
              <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                [list]="listTypeDocument" [required]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3 col-12">
              <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                [recovery]="true" (onChangeTextOnBlur)="changeDocument($event)"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-10 ">
              <app-custom-input-text formControlName="digitVerification" [labelText]="'DV'">
              </app-custom-input-text>
            </div>
            <div class="col field-button">
              <app-custom-button [title]="'Cambiar Documento'" [icon]="'pi pi-sync'"
                (onClick)="openChangeDocumentModal()">
              </app-custom-button>
              <app-custom-modal #changeDocumentModal [label]="'Cambiar Documento'" [width]="'25rem'"
                [header]="'Cambiar Documento'" [inputs$]="inputsForChangeDocumentModals$"
                [children]="componentChangeDocumentModal" (params)="reloadTransporter($event)" hidden>
              </app-custom-modal>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'"
                (onChangeTextOnBlur)="getTransporterByName()" [maxLength]="75"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-10">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateTransporter">
              </app-custom-tag>
            </div>
            <div class="col field-button">
              <app-custom-button [title]="titleState" [icon]="'pi pi-undo'" [severity]="'primary'"
                (onClick)="changeStateTransporter()">
              </app-custom-button>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-12">
              <app-custom-input-text formControlName="phone" [labelText]="'Teléfono'" [required]="true"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-12">
              <app-custom-input-text formControlName="alterPhone" [labelText]="'Teléfono Alterno'"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swExternal" [labelText]="'Externo'"></app-custom-checkbox>
            </div>
            <div *ngIf="swInvoiceTransport" class="col-lg-4 col-md-4 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="providerId" [labelText]="'Empresa Transportadora'"
                [list]="listProviders" [required]="swInvoiceTransport">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-1 d-flex align-items-end mt-1">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>